import {AbstractControl} from '@angular/forms';

export function cnamValidator(control: AbstractControl): {[key: string]: any} | null {
  if (control.value) {

    const regexBadEncoding = /[^\x00-\xFF]/;
    const regexSpecialChars = /^\*|^\s|[\x00-\x1F\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F\x80-\xFF]/;
    const regexAlphaChars = /[A-Za-z]/;
    const cnam = control.value;

    if (cnam.length > 15) {
      return { invalidCnamLength: true };
    }

    if (regexBadEncoding.test(cnam)) {
      return { invalidCnamBadEncoding: true };
    }

    if (regexSpecialChars.test(cnam)) {
      return { invalidCnamSpecialCharacters: true };
    }

    if (!regexAlphaChars.test(cnam)) {
      return { invalidCnamAlphaCharacters: true };
    }
  }

  return null;
}
